
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/mixpanel",
      function () {
        return require("private-next-pages/destinations/mixpanel.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/mixpanel"])
      });
    }
  